import { render, staticRenderFns } from "./productCode21.vue?vue&type=template&id=407957e8&scoped=true&"
import script from "./productCode21.vue?vue&type=script&lang=js&"
export * from "./productCode21.vue?vue&type=script&lang=js&"
import style0 from "./productCode21.vue?vue&type=style&index=0&id=407957e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407957e8",
  null
  
)

export default component.exports